import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@chakra-ui/react';
import { Suspense, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom-v7';
import LayoutWrapper from '../@core/layouts/components/layout-wrapper';
import LoadingSpinner from '../components/general/LoadingSpinner';
import Auth0Callback from '../components/sessions/Auth0Callback';
import ForgotPasswordForm from '../components/sessions/ForgotPasswordForm';
import ResetPasswordForm from '../components/sessions/ResetPasswordForm';
import LoginForm from '../components/sessions/SessionNew';
import VerticalLayout from '../containers/DefaultLayout/VerticalLayout';
import Dashboard from '../views/Dashboard';
import Error from '../views/pages/misc/Error';
import SessionsRoutes from './SessionsRoutes';
// Layout components for different route types
const AuthenticatedLayout = () => {
    const { auth, currentAdmin } = useSelector(state => ({
        auth: state.auth,
        currentAdmin: state.admins.current_admin
    }));
    const isLoggedIn = useMemo(() => !!(auth.isAuthenticated && currentAdmin?.id), [auth.isAuthenticated, currentAdmin?.id]);
    if (!isLoggedIn)
        return _jsx(Navigate, { to: "/login", replace: true });
    return (_jsx(VerticalLayout, { children: _jsx(LayoutWrapper, { children: _jsx(Suspense, { fallback: _jsx(Box, { position: "relative", width: "100%", height: "calc(100vh - 134px)", children: _jsx(LoadingSpinner, {}) }), children: _jsx(Outlet, {}) }) }) }));
};
// Complete React Router 6 implementation
export default function MFRouterRR7() {
    const auth = useSelector(state => state.auth);
    if (!auth.isInitialized)
        return _jsx(LoadingSpinner, {});
    return (_jsx(BrowserRouter, { children: _jsxs(Routes, { children: [_jsxs(Route, { element: _jsx(SessionsRoutes, {}), children: [_jsx(Route, { index: true, element: _jsx(Navigate, { to: "/login", replace: true }) }), _jsx(Route, { path: "/login", element: _jsx(LoginForm, {}) }), _jsx(Route, { path: "/forgot_password", element: _jsx(ForgotPasswordForm, {}) }), _jsx(Route, { path: "/reset_password/:token", element: _jsx(ResetPasswordForm, {}) }), _jsx(Route, { path: "/auth0_callback", element: _jsx(Auth0Callback, {}) })] }), _jsxs(Route, { element: _jsx(AuthenticatedLayout, {}), children: [_jsx(Route, { index: true, element: _jsx(Navigate, { to: "/dashboard", replace: true }) }), _jsx(Route, { path: "/dashboard", element: _jsx(Dashboard, {}) }), _jsx(Route, { path: "*", element: _jsx(Error, {}) })] })] }) }));
}
